import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProcessSection from '../components/ProcessSection';
import CTA from '../components/CTA';

const ProcessPage = () => {
  return (
    <div className="bg-white">
      <Navbar />
      <div className="pt-32 pb-16 max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-8 h-[1.5px] bg-black/60" />
          <span className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-black/60">How We Work</span>
        </div>
        <h1 className="big-display text-[64px] sm:text-[96px] lg:text-[140px] leading-[0.9]">
          The
          <br />
          <span className="text-black/30">Process.</span>
        </h1>
        <p className="font-body text-black/70 max-w-2xl mt-6 leading-relaxed">
          A simple three-step flow that keeps freight moving without the friction of legacy trucking.
        </p>
      </div>
      <ProcessSection />
      <CTA />
      <Footer />
    </div>
  );
};

export default ProcessPage;
